import { useContext, useEffect, useRef } from 'react';
import { LIVE_FLASH_THROTTLE_MS } from '@constants/timing';
import { StreamContext, useStreamStatus } from '@lib/stream';
import { bump } from '@lib/utils/animate';
import { prefersReducedMotion } from '@lib/utils/motion';

const FLASH_SCALE = 1.5;

/** "Langsung" indicator: a slow pulse while connected and a gentle beat when live data arrives; amber while reconnecting. */
export function LiveIndicator({ on = 'Langsung', off = 'Menyambung ulang…', hideTextOnPhone }: { on?: string; off?: string; hideTextOnPhone?: boolean }) {
  const live = useStreamStatus();
  const { subscribe } = useContext(StreamContext);
  const dot = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    let last = 0;
    return subscribe(() => {
      const now = performance.now();
      if (now - last < LIVE_FLASH_THROTTLE_MS || prefersReducedMotion()) return;
      last = now;
      bump(dot.current, FLASH_SCALE);
    });
  }, [subscribe]);
  return (
    <span className={`live ${live ? 'on' : ''}`} title={live ? 'Data diperbarui langsung' : 'Koneksi langsung terputus, menyambung ulang'}>
      <span ref={dot} className={`dot ${live ? 'dot-green pulse' : 'dot-amber'}`} aria-hidden="true" />
      <span className={hideTextOnPhone ? 'live-text' : undefined}>{live ? on : off}</span>
    </span>
  );
}
